import { useState, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Input, FormControl, FormLabel, FormErrorMessage } from '@chakra-ui/react';
import { Formik, Form, Field } from 'formik';

const PuzzleFiveTwo = () => {
    const navigate = useNavigate();
    const contextSix = useCallback(() => navigate('/BoxThree/ContextSix'), [navigate]);
    const [hint, setHint] = useState('');
    const [attemptCount, setAttemptCount] = useState(0);

    const showHint = () => {
        setHint(prevHint => prevHint ? '' : 'Use the first letter of each riddle\'s answers. They denote a major publishing company.');
    };

    function validateAnswer(value) {
        value = value.replaceAll(' ', '');
        if (value.toLowerCase() === 'nyt' || value.toLowerCase() === 'newyorktimes') {
            return true;
        } else {
            setAttemptCount(prev => prev + 1);
            return false;
        }
    }

    return (
        <div className="App">
            <div className="App-body">
                <h1>Puzzle Five: Decoding </h1>
                {attemptCount >= 3 && (
                    <Button mt={4} bg="#7c55d2" color="white" _hover={{bg:"#5a3cb0"}} onClick={showHint}>
                        {hint ? 'Hide Hint' : 'Show Hint'}
                    </Button>
                )}
                {hint && <p>{hint}<br/><br/><br/></p>}

                <p>
                These documents are not ordinary files; they are crafted puzzles left by Nina, designed to test your acumen and insight. 
                Each one poses a riddle that intertwines the principles of corporate navigation, the give and take of negotiations, 
                and the clear honesty required in whistleblowing. You realize that solving these puzzles is key to progressing further. <br></br><br></br>

                Focus on extracting the essence of each solution. As you unravel the riddles, consider the 
                significance of the letters of each answer. These aren’t just random solutions; 
                they are deliberate clues that might reveal a deeper layer of meaning.

                </p>
                <Formik
                    initialValues={{ answer: '' }}
                    onSubmit={(values, actions) => {
                        if (validateAnswer(values.answer)) {
                            contextSix();
                        } else {
                            actions.setFieldError('answer', 'Answer is Incorrect');
                        }
                        actions.setSubmitting(false);
                    }}
                >
                    {( props ) => (
                        <Form>
                            <Field name='answer'>
                                {({ field, form }) => (
                                    <FormControl isInvalid={form.errors.answer && form.touched.answer}>
                                        <FormLabel>Answer</FormLabel>
                                        <Input {...field} placeholder='Answer' />
                                        <FormErrorMessage>{form.errors.answer}</FormErrorMessage>
                                    </FormControl>
                                )}
                            </Field>
                            <Button mt={4} bg="#7c55d2" color="white" _hover={{bg:"#5a3cb0"}} isLoading={props.isSubmitting} type='submit'>
                                Continue
                            </Button>
                      </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
  };
  
export default PuzzleFiveTwo;
  